import React, { useMemo, useEffect, useCallback } from 'react';
import ProductFiltering from '../ProductFiltering/ProductFiltering';
import SideMenu from '../SideMenu/SideMenu';
import { translate } from '../../Services/translation';
import ProductSortingRadios from './ProductSortingRadios';
import { clearAllFilters } from '../../Actions/ProductFiltering.action';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import Collapsible from '../Collapsible';

const FilterMenu = ({
  currentMenu,
  setCurrentMenu,
  totalActiveFilters,
}) => {
  const dispatch = useDispatch();
  const { totalProductsCount } = useTypedSelector(
    (state) => state.productListing
  );
  const productFiltering = useTypedSelector(
    (state) => state.productFiltering
  );
  const { filters } = productFiltering;

  const hasAnyOptionSelected = useMemo(
    () => filters?.some((obj) => obj.selectedOptions.length > 0),
    [filters]
  );

  const { sortCriteria } =
    useTypedSelector((state) => state.productFiltering) ?? {};
  const selectedSortItemName = useMemo(
    () => sortCriteria?.sortItems.find((s) => s.selected)?.name,
    [sortCriteria]
  );

  const SortingHeader = useCallback(
    () => (
      <div className="flex w-full items-center justify-between pr-2">
        <span className="h4">{translate('filter.sorting-label')}</span>
        <span className="font-akzidenz text-sm text-gray-500">
          {selectedSortItemName}
        </span>
      </div>
    ),
    [selectedSortItemName]
  );

  const Header = () => (
    <>
      {currentMenu == 'filtersAndSorting' ? (
        <h4 className="flex w-full items-center">
          {translate('filter.filters-and-sorting')}
          {totalActiveFilters >= 1 && (
            <div className="ml-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-gray-700 ">
              <span className="font-akzidenz text-sm text-white">
                {totalActiveFilters}
              </span>
            </div>
          )}
        </h4>
      ) : null}
    </>
  );

  const Footer = useCallback(
    () => (
      <>
        {currentMenu == 'filtersAndSorting' ? (
          <>
            <button
              className="btn btn--outline-black btn--large mr-2 w-full font-bold uppercase"
              disabled={!hasAnyOptionSelected}
              onClick={() => dispatch(clearAllFilters())}
            >
              {translate('filter.clear')}
            </button>
            <button
              className="btn btn--black btn--large w-full"
              onClick={() => setCurrentMenu(undefined)}
            >
              {translate('filter.view')} ({totalProductsCount})
            </button>
          </>
        ) : null}
      </>
    ),
    [currentMenu, hasAnyOptionSelected, setCurrentMenu, totalProductsCount]
  );

  return (
    <>
      <SideMenu
        from="right"
        id="filter-menu"
        open={!!currentMenu}
        onClosed={() => setCurrentMenu(undefined)}
        components={{ Header, Footer }}
        className="z-[60] rounded"
        contentClassName="flex-1 overflow-y-auto"
      >
        <>
          {currentMenu == 'filtersAndSorting' ? (
            <div className=" flex-1 overflow-y-auto border-y border-gray-100 [&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content_button]:mt-4 [&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content_label]:px-0 [&_.ReactCollapse--collapse[aria-hidden='false']_.ReactCollapse--content_label]:py-1 [&_.collapsible(:last-child)]:border-0 [&_.collapsible]:border-b [&_.collapsible]:border-t-0 [&_.collapsible]:border-gray-300">
              <Collapsible
                className="border-b border-solid !border-gray-100 px-4 first:border-t-0"
                label={<SortingHeader />}
                labelClassName="!text-h5 h5 [&_>svg]:!w-5 [&_>svg]:!h-5 store-screen:py-3"
                contentClassName="[&_.ReactCollapse--content]:pb-4"
              >
                <ProductSortingRadios />
              </Collapsible>
              <ProductFiltering />
            </div>
          ) : null}
        </>
      </SideMenu>
    </>
  );
};

export default FilterMenu;
